<template>
<div class="auth">
  <div class="columns">
    <div class="column is-full-height is-hidden-mobile is-half branding-half">
      <article class="has-text-centered">
        <a href="http://wavve.co/">
          <img style="max-width:40%; height:auto; display:block;margin:0 auto;"
            src="https://app.wavve.co/img/logo-white-text-under.0d5d5429.png"/>
        </a>
        <h3> Grow your audience. Fast.</h3>
      </article>
    </div>
    <div class="column is-full-height is-half form-half">
      <article class="signup-container">
        <h4 class="is-size-4 has-padding-bottom">Welcome back to Wavve!</h4>
        <div class="has-margin-top">
          <el-form @submit.prevent.native="onSubmit" label-position="left" label-width="80px">
            <el-form-item label="Email">
              <el-input type="email" v-model="email"></el-input>
            </el-form-item>
            <el-form-item label="Password">
              <el-input show-password type="password" v-model="password"></el-input>
            </el-form-item>
            <el-button v-loading="pending" native-type="submit" type="primary" :style="{width: '70%'}"> Log In</el-button>
          </el-form>
        </div>
      </article>
    </div>
  </div>
</div>
</template>

<script>
import { LOGIN } from '@/store/action-types';

export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      pending: false,
      lastPath: null,
    }
  },
  async created() {
    this.lastPath = '/manager';
  },
  methods: {
    async onSubmit(evt) {
      evt.preventDefault();
      try {
        this.pending = true;
        await this.$store.dispatch(LOGIN, { email: this.email, password: this.password });
        if (this.$store.state.authStatus === 'success') {
          this.$router.push(this.lastPath);
        } else {
          this.pending = false
        }
      } catch (err) {
        // use elements notification system
        console.log('error', err.message);
        this.pending = false
      }
    },
  }
}
</script>


<style lang="scss" scoped>
@import '../style/main.scss';
$brand-green: #25bab0;
$brand-blue: #319bbf;
article {
  position: relative;
  top: 50%;
  text-align: center;
  transform: translate(0, -50%);
  padding: 1rem;
  @include breakpoint(mobile) {
    top: 0;
    transform: translate(0, 10%);
  }
}
.branding-half {
  background-color: $brand-green;
  color: white;
  height: 102vh;
  background-image:
  linear-gradient(
    to top left,
    $brand-green, $brand-blue
  )
}
</style>
